import _ from 'lodash';
import React from 'react';
import AnimateHeight from 'react-animate-height';
import AccessibleDiv from 'components/AccessibleDiv/AccessibleDiv';
import DocumentThumbnail from 'components/DocumentThumbnail';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import LayoutListItemRendition from 'components/LayoutListItemRendition';
import { DocumentSubtype } from 'const';
import { ReusableLayoutMap, GroupLayoutDocumentMap } from 'models';
import styles from './styles.module.scss';

type Props = {
  container?: React.Ref<HTMLDivElement>;
  document: ReusableLayoutMap | GroupLayoutDocumentMap;
  isPreview?: boolean;
  thumbnailUrl: string;
  layoutCount?: number;
  isOutsideStoryCard?: boolean;
  dataTestId?: string;
  isGroupLayout: boolean;
};

export const LayoutListItemContent: React.FunctionComponent<Props> = (props) => {
  const {
    children,
    container,
    document,
    isPreview,
    thumbnailUrl,
    layoutCount,
    isOutsideStoryCard,
    dataTestId = 'layoutListItemContent',
    isGroupLayout,
  } = props;

  const [isExpanded, setIsExpanded] = React.useState(false);
  const handleToggleExpand = (): void => setIsExpanded(!isExpanded);

  const name = document.get('name');
  const number = document.get('number');
  const product = document.get('product');
  const productName = product?.first();

  const allowExpandLayout = !isPreview && !isGroupLayout && document.get('subtype') === DocumentSubtype.CONTENT_UNIT;

  return (
    <div
      className={styles.content}
      ref={container}
      data-testid={dataTestId}
    >
      <div className={styles.layoutWrapper} data-testid={`${dataTestId}-layoutWrapper`}>
        <div className={styles.layout} data-testid={`${dataTestId}-layoutWrapper-layout`}>
          <div className={styles.iconWrapper}>
            <div className={styles.thumb}>
              {
                isGroupLayout &&
                <Icon className={styles.groupLayoutMarker} type={IconType.GROUP_LAYOUT} size="xs" color="primary" />
              }
              <DocumentThumbnail
                placeholder={<Icon type={IconType.IMAGE} size="sm" color="disabled" />}
                url={thumbnailUrl}
              />
            </div>
            {_.isFinite(layoutCount) && isOutsideStoryCard && <div className={styles.counter}>{layoutCount}</div>}
          </div>
          <div className={styles.info}>
            <div className={styles.title}>{name}</div>
            <div className={styles.name}>
              <span className={styles.name__primary}>{number}</span>
              {productName && <span className={styles.name__secondary}>{productName}</span>}
            </div>
          </div>
          {children}
        </div>
        {allowExpandLayout &&
          <AccessibleDiv
            className={styles.chevron}
            onClick={handleToggleExpand}
            data-testid={`${dataTestId}-layoutWrapper-button`}
          >
            <Icon
              type={isExpanded ? IconType.CHEVRON_UP : IconType.CHEVRON_DOWN}
              size="badge"
              color="primary"
            />
          </AccessibleDiv>
        }
      </div>
      <AnimateHeight
        duration={300}
        easing="ease-out"
        height={isExpanded ? 'auto' : 0}
      >
        <LayoutListItemRendition document={document} dataTestId={`${dataTestId}-rendition`} />
      </AnimateHeight>
    </div>
  );
};
